// Shared rating-edit window calculation. Used by PendingRatingsAlert,
// ArtifactItem, and WorkAssessment so the alert, the deadline countdown,
// and the page's submit gating all agree on when a student can rate.

const DAY_MS = 24 * 60 * 60 * 1000;

// Normalize Firestore Timestamp / Date / ISO string / structured-cloned
// { seconds, nanoseconds } → milliseconds since epoch. Returns null if
// the input cannot be interpreted.
export const toMillis = (ts) => {
    if (ts == null) return null;
    if (typeof ts.toMillis === 'function') return ts.toMillis();
    if (typeof ts.toDate === 'function') return ts.toDate().getTime();
    if (typeof ts.seconds === 'number') return ts.seconds * 1000;
    if (ts instanceof Date) return ts.getTime();
    if (typeof ts === 'string') {
        const ms = new Date(ts).getTime();
        return Number.isNaN(ms) ? null : ms;
    }
    return null;
};

// Compute when the user's rating-edit window closes (ms since epoch).
//
//   - Re-rate (artifact updated after user rated): window starts at
//     artifactLastModifiedAt — the student is rating a new artifact
//     version, so the instructor's window applies fresh.
//   - Edit (user revising their own submission): window starts at
//     submittedAt.
//
// Both are capped by reviewDeadline. Returns null when the start
// timestamp can't be resolved (caller should treat as "no constraint").
export const computeRatingWindowEndMs = ({
    isReRate,
    artifactLastModifiedAt,
    submittedAt,
    reviewDeadline,
    editWindowDays,
}) => {
    const startMs = isReRate
        ? toMillis(artifactLastModifiedAt) ?? toMillis(submittedAt)
        : toMillis(submittedAt);
    if (startMs == null) return null;

    const editEndMs = startMs + editWindowDays * DAY_MS;
    const reviewEndMs = toMillis(reviewDeadline);
    return reviewEndMs != null ? Math.min(editEndMs, reviewEndMs) : editEndMs;
};

export const RATING_WINDOW_DAY_MS = DAY_MS;
